export default __webpack_public_path__ + "static/media/equalTo.7f282066.svg";